<template>
  <div>
    <el-popover
        placement="bottom"
        width="300"
        trigger="click"
    >
      <div class="msg-list">
        <p
            v-if="!iTotalRecords"
            style="color:#999;text-align: center;"
        >没有新消息</p>
        <div>
          <div class="listbox">
            <p
                class="p"
                v-for="(item, index) in recordsDate"
                :key="index"
            >
              <el-link
                  type="primary"
                  @click="goto(item.bk_id, item.type, item.id)"
              >
                <el-badge
                    is-dot
                    class="item"
                ><span class="texts">{{ `【${item.type == 1 ? '关注人物' : '关注物品'}】${item.content}` }}</span></el-badge>
              </el-link>
            </p>
          </div>
        </div>
      </div>
      <el-badge
          :value="iTotalRecords"
          class="item-badge"
          slot="reference"
          :hidden="!iTotalRecords"
      >
        <el-button
            size="small"
            class="el-icon-message msg-btn"
        ></el-button>
      </el-badge>
      <div style="text-align: center;border-top: 1px solid #cecdcd;line-height: 35px; height: 26px;"><a href="/message_list" style="color:#333" >查看更多</a> </div>
    </el-popover>
  </div>
</template>

<script>
import {messageList, showUserMessage} from "@/api/user";
import apiUser from "@/api/config/user";
import config from "@/config";

export default {
  data() {
    let self = this;
    return {
      abs_path: config.ABS_PATH,
      hosts: window.location.origin,
      iTotalRecords: 0,
      recordsDate: [],
      queryForm: {
        status: 0,
        pageSize: 10,
        curPage: 1
      }
    };
  },
  mounted() {
    this.userMessageList();
    setInterval(() => {
      this.userMessageList();
    }, 30000);
  },
  methods: {
    async goto(id, type, msgid) {
      const reslut = await showUserMessage({
        id: msgid
      });
      this.userMessageList();
      console.log();
      if (type == 1) {
        if (this.$route.path == "/people_list") {
          this.$router.push({
            path: "/people_list",
            query: {id: id}
          });
          setTimeout(() => {
            this.$router.go(0);
          });
        } else {
          this.$router.push({
            path: "/people_list",
            query: {id: id}
          });
        }
      } else {
        if (this.$route.path == "/goods_list") {
          this.$router.push({
            path: "/goods_list",
            query: {id: id}
          });
          setTimeout(() => {
            this.$router.go(0);
          });
        } else {
          this.$router.push({
            path: "/goods_list",
            query: {id: id}
          });
        }
      }
    },
    async userMessageList() {
      // const result = await messageList(this.queryForm);
      // console.log(result);
      let prefixData = Object.create(null);
      prefixData = {
        appkey: config.APP_KEY
      };
      if (window.localStorage.getItem("token")) {
        prefixData.token = window.localStorage.getItem("token");
      } else {
        return;
      }
      this.$axios({
        method: "post",
        url:
            window.location.origin +
            config.ABS_PATH +
            apiUser.user_message_list,
        headers: {
          ...prefixData
        },
        params: this.queryForm
      })
          .then(re => {
            // console.log(re);
            let result = re.data.data;
            this.iTotalRecords = result.iTotalRecords;
            this.recordsDate = result.aaData;
            // this.iTotalRecords = 54;
            // this.recordsDate = [
            //     {
            //         bk_id: 1,
            //         title: "【物品找物】1查找到新物品查找到新物品"
            //     },
            //     {
            //         bk_id: 2,
            //         title: "【物品找物】2查找到新物品查找到新物品"
            //     },
            //     {
            //         bk_id: 3,
            //         title: "【物品找物】3查找到新物品查找到新物品"
            //     }
            // ];
          })
          .catch(err => {
            console.log(err);
          });
    }
  }
};
</script>
<style>
</style>

<style scoped lang="scss">

.msg-list {

  height: 450px;
  overflow: auto;
  .listbox {
    .p {
      margin-bottom: 12px;

      .texts {
        display: inline-block;
        width: 258px;
        /*     overflow: hidden;
             text-overflow: ellipsis;
             white-space: nowrap;*/
      }
    }
  }

  .change {
    display: flex;
    justify-content: center;
  }
}

.item-badge {
  margin-right: 40px;

  .msg-btn {
    background: none;
    font-size: 26px;
    padding: 0;
    border: 0;
  }
}
</style>
